var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._t("default",function(){return _vm._l((_vm.options),function(option){return _c('ButtonBorderedIcon',{key:option.value,staticClass:"button-bordered-icon-options__option",attrs:{"active":option.value === _vm.value,"icon":option.icon,"title":option.title},on:{"click":function($event){return _vm.$emit('update', option.value)}}})})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }